import React from 'react'
import styles from './Button.module.css'

export const Button = React.memo(({children, customClasses, ...otherProps}) => {
    return(
        <button className={`cursor-pointer ${styles.button} ${customClasses}`} {...otherProps} >
            { children }
        </button>
    )
})